export const types = {
  'MENU/TOGGLE': 'MENU/TOGGLE',
  'MENU/SET_ACTIVE_ITEM': 'MENU/SET_ACTIVE_ITEM'
}
